import { FunctionComponent, useEffect } from 'react'

import styled from 'styled-components'

import BonusIcon from 'src/Assets/Svg/referAndEarn/bonus.svg?react'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { StatsBlock } from 'src/Components/StatsSectionBlock'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import {
  getBonusPerCampaign,
  getInvitedArtists,
  getReferralList,
  getReferredArtists,
  getTotalBonus,
} from 'src/Redux/referral-process/referralList/selectors'
import { numberToMoney } from 'src/Constants/functions'
import { getReferralUserList } from 'src/Redux/referral-process/referralList/api-actions'

import { InviteBlock } from './components/InviteBlock'
import { MainInfo } from './MainInfo'
import { ErrorBlock } from './components/ErrorBlock'

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 40px;
    padding-bottom: 56px;
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    gap: 80px;
  }
`

export const ReferAndEarnPage: FunctionComponent = () => {
  const total = useAppSelector(getTotalBonus)
  const bonusPerCampaign = useAppSelector(getBonusPerCampaign)
  const invitedArtists = useAppSelector(getInvitedArtists)
  const referralArtists = useAppSelector(getReferredArtists)
  const dispatch = useAppDispatch()
  const referralList = useAppSelector(getReferralList)

  useEffect(() => {
    void dispatch(getReferralUserList())
  }, [dispatch])

  const sections = [
    {
      title: 'Total bonus earned',
      value: `$${numberToMoney(total)}`,
    },
    {
      title: 'Total artists invited',
      value: invitedArtists,
    },
    {
      title: 'Bonus per campaign',
      value: `$${numberToMoney(Number(bonusPerCampaign))}`,
    },
  ]

  return (
    <PageContainer>
      <Content>
        <StatsBlock sections={sections} icon={<BonusIcon />} />
        <InviteBlock />
        <MainInfo
          referralArtists={referralArtists}
          referralList={referralList}
        />

        <ErrorBlock />
      </Content>
    </PageContainer>
  )
}
